import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as IMedicalExaminationState } from '../../common/store/medicalExaminations/state';
import { IActions as IMedicalExaminationActions } from '../../common/store/medicalExaminations/actions/creators';
import { actionCreator as medicalExaminationsActions } from '../../common/store/medicalExaminations/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import Filters from './components/Filter/Filters';
import ValidateMexDialog from './components/Detail/ValidateMexDialog';

import { MexList } from './components/List/MexList';
import { medicalExamination } from '../../model/medicalexamination';
import { useEffect, useState } from 'react';

interface IProps extends IMedicalExaminationActions, IMedicalExaminationState, IMediaQueryProps, StyledComponentProps {
}

// interface IState {
//     //     medicalExaminationList: ;
//     //     selectedMedicalExamination: medicalExamination,
//     //     fullnameOrEmail: string;
//     sub: string;
//     //     isLoadingMex: boolean,
//     //     // openDialog: boolean;
// }

//class CompContainer extends React.Component<IProps, IState> {
const CompContainer = (props: IProps) => {
    // state = {
    //     //     medicalExaminationList: [],
    //     //     selectedMedicalExamination: undefined,
    //     //     fullnameOrEmail: "",
    //     sub: "",
    //     //     isLoadingMex: false,
    // };

    const [openDialog, setOpenValidateDialog] = useState<boolean>(false);
    // const [sub, setSub] = useState<string>(undefined);
    const [medicalExaminationList, setMedicalExaminationList] = useState<medicalExamination[]>([]);
    const [selectedMedicalExamination, setSelectedMedicalExamination] = useState<medicalExamination>(undefined);

    useEffect(() => {
        console.info("USE EFFECT MEX ------------------------------------------------")
        console.log(window.location.pathname);
        if (medicalExaminationList.length === 0
            && window.location.pathname.indexOf('MedicalExaminations') > 0) {
            props.loadMedicalExaminationsToBeValidate();
            // LOAD MEDICAL EXAMINATION TO VALIDATE...
        }
    }, []);

    useEffect(() => {
        console.info("USE EFFECT MEX ------------------------------------------------ props.medicalExaminations", props.medicalExaminations)
        let _mexArray: medicalExamination[] = [];
        props.medicalExaminations.forEach(mex => {
            _mexArray.push(mex);
        })
        if (_mexArray.length > 0) {
            setMedicalExaminationList(_mexArray);
        }
    }, [props.medicalExaminations]);

    // useEffect(() => {
    //     console.info("USE EFFECT MEX ------------------------------------------------ state.sub", state.sub)
    // }, [state.sub]);


    //componentDidMount() {
    //
    //    // console.info("componentDidMount ----> medicalExaminations", this.props.medicalExaminations)
    //    // console.info("componentDidMount ----> selectedMedicalExamination", this.state.selectedMedicalExamination)
    //    // console.info("COMPONENTDIDMOUNT MEX ------------------------------------------------", this.props.medicalExaminations)
    //    // console.info("COMPONENTDIDMOUNT MEX ------------------------------------------------", this.props.medicalExaminations.length)
    //    // console.info("COMPONENTDIDMOUNT MEX ------------------------------------------------", this.props.isLoadingMex)
    //    // const { id } = this.props.match.params;
    //    // if (!this.props.medicalExaminations || this.props.medicalExaminations.length === 0) {
    //    //     this.props.loadMedicalExaminationsToBeValidate();
    //    //     // LOAD MEDICAL EXAMINATION TO VALIDATE...
    //    // }
    //}

    //const getObjectDiff = (original, current) => {
    //    const changes = {};
    //
    //    // Check current object's properties
    //    for (const [key, value] of Object.entries(current)) {
    //        if (!(key in original)) {
    //            changes[key] = {
    //                oldValue: undefined,
    //                newValue: value
    //            };
    //            continue;
    //        }
    //
    //        const originalValue = original[key];
    //        const currentValue = value;
    //
    //        // Handle different types of comparisons
    //        if (
    //            originalValue !== currentValue &&
    //            String(originalValue) !== String(currentValue) &&
    //            JSON.stringify(originalValue) !== JSON.stringify(currentValue)
    //        ) {
    //            changes[key] = {
    //                oldValue: originalValue,
    //                newValue: currentValue
    //            };
    //        }
    //    }
    //
    //    // Check for removed properties
    //    for (const key of Object.keys(original)) {
    //        if (!(key in current)) {
    //            changes[key] = {
    //                oldValue: original[key],
    //                newValue: undefined
    //            };
    //        }
    //    }
    //
    //    return Object.keys(changes).length === 0 ? null : changes;
    //}

    //componentDidUpdate(prevProps, prevState) {
    //
    //    console.info("COMPONENT DID UPDATE MEX ------------------------------------------------", this.props.medicalExaminations)
    //    console.info("COMPONENT DID UPDATE MEX ------------------------------------------------", this.props.isLoadingMex)
    //    //console.info("COMPONENTDIDUPDATE MEX ------------------------------------------------", this.state.selectedMedicalExamination)
    //    console.info("COMPONENT DID UPDATE MEX ------------------------------------------------", this.state.sub)
    //
    //    if (this.props.isLoadingMex === false
    //        && this.state.sub === ''
    //        // && this.state.medicalExaminationList.length === 0
    //        && this.props.medicalExaminations.length === 0) {
    //        // cerco tutti gli utenti da validare
    //        // this.setFiltro(null, null)
    //        this.props.loadMedicalExaminationsToBeValidate();
    //    }
    //
    //    if (this.props.isLoadingMex === false
    //        && this.props.medicalExaminations.length > 0) {

    //    }
    //
    //    if (this.props.isLoadingMex === false
    //        && this.props.medicalExaminations.length > 0
    //        && this.state.selectedMedicalExamination) {
    //        // HO DEI DATI CARICATI E HO UN ELEMENTO SELEZIONATO
    //        const id = this.state.selectedMedicalExamination._id;
    //        const sel = this.props.medicalExaminations.find(item => {
    //            if (item._id === id) {
    //                return true;
    //            }
    //        })
    //        console.info("componentDidUpdate ----> SEL:", sel)
    //        const test = this.getObjectDiff(this.state.selectedMedicalExamination, sel)
    //        if (test) {
    //            console.info("componentDidUpdate ----> TEST:", test)
    //            // update list items
    //            this.setState({ selectedMedicalExamination: undefined });
    //            let ids = [...this.state.medicalExaminationList];
    //            let index = ids.findIndex(el => el._id === id);
    //            ids[index] = sel;
    //            this.setState({ medicalExaminationList: ids });
    //
    //        }
    //    }
    //}

    // componentWillReceiveProps(NextProps) {
    //     console.log("componentWillReceiveProps -------------------> ", NextProps);
    //     console.info("componentWillReceiveProps ----> selectedMedicalExamination", this.state.selectedMedicalExamination)
    // }

    // const setOpenValidateDialog = (open: boolean) => {
    //     setOpenDialog(open);
    // }

    // setFiltro = (nameOrEmail: string, sub: string) => {
    //     console.info("SET FILTRO MEX ------------------------------------------------", nameOrEmail, sub, this.props.medicalExaminations.length, " items")
    //     let _mexArray: medicalExamination[] = [];
    //     this.props.medicalExaminations.map(mex => {
    //         _mexArray.push(mex);
    //     })
    //     if (_mexArray.length > 0) {
    //         this.setState({ medicalExaminationList: _mexArray });
    //     }
    // }

    const handleSelection = (_id: string) => {
        console.log("handle selection", _id)
        const selected = medicalExaminationList.find((element: medicalExamination) => element._id === _id)
        if (selected.isDeleted) {
            console.warn("document deleted. action disabled", selected)
        }
        else if (selected.isValidateByGym === false) {
            console.log("handle selection selected", selected)
            setSelectedMedicalExamination(selected);
            setOpenValidateDialog(true);
        }
    }

    const closeDialog = () => {
        setOpenValidateDialog(false)
        setSelectedMedicalExamination(undefined);
    }

    const saveMex = (item: medicalExamination) => {
        console.info("SAVE MEX ------------------------------------------------", item)
        props.validateMedicalExamination(item.sub, item);
        setOpenValidateDialog(false);
    }

    const deleteMex = (item: medicalExamination) => {
        console.info("DELETE MEX ------------------------------------------------", item)
        props.deleteMedicalExamination(item.sub, item);
        setOpenValidateDialog(false);
    }

    // handleFilter = (filtro: string) => {
    //     // this.setState({ birthDay: filtro });
    //     this.setFiltro(filtro)
    // }

    // const handleChangeFullnameOrEmail = (val: string) => {
    //     // setState({ fullnameOrEmail: val })
    // }

    // const handleChangeSub = (val: string) => {
    //     console.info("HANDLE CHANGE SUB MEX ------------------------------------------------", val)
    //     // setSub(val)
    // }

    const search = (_fullnameOrEmail: string, _sub: string) => {
        console.info("SEARCH MEX ------------------------------------------------BY SUB", _sub)
        // this.props.clearContactPurchased();
        // this.props.loadContactsPaginated(fullnameOrEmail, tag ? tag.code : "", page, DefaultRowsPerPage)
        setMedicalExaminationList([]);
        setSelectedMedicalExamination(undefined);
        if (_sub && _sub !== '') {
            props.loadMedicalExaminationsByUser(_sub);
        }
        else {
            props.loadMedicalExaminationsToBeValidate();
        }
    }


    // const { id } = this.props.match.params;
    // const { classes } = this.props;
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Filters
                    // handleChangeFullnameOrEmail={handleChangeFullnameOrEmail}
                    // handleChangeSub={handleChangeSub}
                    search={search}
                    // fullnameOrEmail={undefined}
                    // sub={sub}
                    classes={props.classes}
                    loading={props.isLoadingMex}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <Paper title='Elenco Documenti Visite Medica DA VALIDARE'
                    collapsed={props.smallScreen ? true : false} // true --> this.state.contactsCollapsed 
                    fullHeight={false}
                    contentContainerStyle={props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                    <Grid>
                        {props.isLoadingMex ?
                            <Grid item xs={12} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            :
                            <>
                                <Grid item xs={12} >
                                    <MexList
                                        classes={props.classes}
                                        medicalExaminationList={medicalExaminationList}
                                        selected={selectedMedicalExamination?._id}
                                        onMedicalExaminationClick={handleSelection}
                                    />
                                </Grid>
                            </>
                        }
                    </Grid>
                </Paper>
                <ValidateMexDialog
                    open={openDialog}
                    onCancel={closeDialog}
                    onSave={saveMex}
                    onDelete={deleteMex}
                    medicalExaminationSelected={selectedMedicalExamination}
                    // onSaveInsurance={this.saveInsurance}
                    // onSaveMedicalExamination={this.saveMedicalExamination}
                    classes={props.classes}
                />
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.medicalExaminations,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...medicalExaminationsActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const MedicalExaminations = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles as any)(WithMediaQuery(CompContainer)));